import type {ListVariation} from '~/types'
import {isLevantaVariation} from '~/utils/list-variation'

/**
 * Which optional list widgets render. The LEVANTA page is Levanta products end to end: sponsored (DWS)
 * products, DWS related products, related lists and popular categories are BASELINE-only widgets there.
 * The other rules are the pre-existing US / Spanish / domain rules, moved here unchanged.
 */
export function getListSectionVisibility({
  variation,
  isUSLocale,
  domainName,
  forcedLanguage,
}: {
  variation?: ListVariation
  isUSLocale: boolean
  domainName: string
  forcedLanguage?: string
}) {
  const isLevanta = isLevantaVariation(variation)
  const isSpanish = forcedLanguage?.toLowerCase() === 'es'

  return {
    showSponsoredProducts: !isLevanta,
    showRelatedProducts: !isLevanta && !isSpanish,
    showRelatedLists: !isLevanta,
    showPopularCategories: !isLevanta && isUSLocale && domainName === 'bestreviews' && !isSpanish,
    // The product-features page is the BASELINE page: its CTA rebuilds the outbound link from the
    // catalog product, dropping the Levanta attribution, so the LEVANTA list does not link to it.
    showProductPageLinks: !isLevanta,
  }
}
